<template>
  <v-card :color="backgroundColor" :theme="theme" flat tile>
    <BannerCardInner :compact="compact" :value="value" />
  </v-card>
</template>

<script setup lang="ts">
import type { components } from '#root/types/directus'
import { computed } from 'vue'

const props = defineProps<{
  compact?: boolean
  value: components['schemas']['ItemsBanners']
}>()

const backgroundColor = computed(() => {
  const scheme = props.value.color_scheme
  if (
    scheme &&
    typeof scheme === 'object' &&
    scheme.background_color &&
    typeof scheme.background_color === 'object' &&
    scheme.background_color.id
  ) {
    return scheme.background_color.id
  }
  return 'surface-light'
})

const theme = computed(() => {
  const scheme = props.value.color_scheme
  if (scheme && typeof scheme === 'object') return scheme.theme ?? undefined
  return undefined
})
</script>
